import Api from '@/api/Api'

export default {
  confirmEmail (params) {
    return Api().post('User/confirm_email', params)
  },

  getListUser (params) {
    return Api().post('User/get_list_user', params)
  },

  /* Customer */
  getCS (params) {
    return Api().post('User/get_cs', params)
  },
  createCS (params) {
    return Api().post('User/create_cs', params)
  },
  updateCS (params) {
    return Api().put('User/update_cs/' + params._id, params)
  },
  updatePWCS (params) {
    return Api().put('User/update_pw_cs/' + params._id, params)
  },
  /* END Customer */

  /* Guider */
  getGD (params) {
    return Api().post('User/get_gd', params)
  },
  createGD (params) {
    return Api().post('User/create_gd', params)
  },
  updateGD (params) {
    return Api().put('User/update_gd/' + params._id, params)
  },
  changeStatusGuiderCustomer (params) {
    return Api().post('User/change_status_guider_customer', params)
  }
  /* END Guider */
}



// WEBPACK FOOTER //
// ./src/api/UserAPI.js